import { api } from "@api/api";
import { PartnerReferralSummary } from "@modules/partners/types";

export async function getReferralSummaryService(): Promise<PartnerReferralSummary> {
  const { data } = await api.get<PartnerReferralSummary>("/v1/partner_referral_summary_admin/");
  return data;
}
